import React from "react"
import { makeStyles, Paper, Fade } from "@material-ui/core"
import { ShowAtScrollTop } from "../Scrolling/ShowAtScrollTop"

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    width: "100%",
    maxWidth: 768,
    bottom: 20,
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 99999,
    padding: theme.spacing(2),
    borderRadius: theme.cards.hoverCard.borderRadius,
    boxShadow: theme.cards.hoverCard.boxShadow
  }
}))

const FloatingActionBar = ({ children, style, from = 300 }) => {
  const classes = useStyles()

  const renderContent = () => (
    <Paper className={classes.root} elevation={0} style={style}>
      {children}
    </Paper>
  )

  return (
    <ShowAtScrollTop from={from}>
      <Fade in>{renderContent()}</Fade>
    </ShowAtScrollTop>
  )
}

export default FloatingActionBar
